import { createFileRoute } from "@tanstack/react-router";
import { LegalDoc } from "@/components/LegalDoc";

export const Route = createFileRoute("/terms")({
  component: () => <LegalDoc doc="terms" />,
});
